import { BackgroundRotator } from 'Modules/backgroundRotator';
import { Accordion } from 'Modules/accordion';
import { Alerts } from 'Modules/alerts';
import { HeroImage } from 'Modules/heroImage';
import { CarouselBrowser } from 'Modules/carouselBrowser';
import { CTASlider } from 'Modules/ctaSlider';
import { ContentAndMedia } from 'Modules/contentAndMedia';
import { HeroSlider } from 'Modules/heroSlider';
import { ContentAndMediaSlider } from 'Modules/contentAndMediaSlider';
import { ThreeUpSlider } from 'Modules/threeUpSlider';

/**
 * STYLEGUIDE SPECIFIC FUNCTIONS
 */
export namespace Styleguide {
    let initMarkupToggle = () => {
        $('.js-markup-toggle').on('click', function () {
            $(this).next('pre').toggleClass('state-visible');
        });
    };

    let initFieldsToggle = () => {
        $('.js-fields-toggle').on('click', function () {
            $(this).next('.js-fields').toggleClass('state-visible');
        });
    };

    let simulateLoadIndicator = () => {
        let $loadIndicator = $('.js-simulate-load-indicator');

        if (!$loadIndicator) {
            return;
        }

        $loadIndicator.on('click', (e) => {
            e.preventDefault();
            let loadIndicatorItems = $('.js-load-indicator-styleguide');

            loadIndicatorItems.each(function () {
                $(this).removeClass('state-visible');
                $(this).addClass('state-visible');
            });

            setTimeout(function () {
                loadIndicatorItems.each(function () {
                    $(this).removeClass('state-visible');
                });
            }, 3000);
        });
    };
    /**
     * Container Initialization
     */
    export const init = () => {
        initMarkupToggle();
        initFieldsToggle();
        simulateLoadIndicator();
        HeroImage.init();
        Alerts.init();
        ContentAndMedia.init();
        BackgroundRotator.init();
        Accordion.init();
        CarouselBrowser.init();
        CTASlider.init();
        HeroSlider.init();
        ThreeUpSlider.init();
        ContentAndMediaSlider.init();
    };
}

Styleguide.init();
